exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps{width:100%;margin:0 auto;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.steps .step{height:17px;width:17px;margin:0 10px;background-color:#015351;border-radius:50%;opacity:0.4;cursor:pointer}.steps .active{opacity:1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Steps/Steps.scss
// module id = 300
// module chunks = 0